import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/badges/google-play.png")